<dx-select-box [value]="profileItem"
               (valueChange)="profileItemChange.emit($event)"
               [dataSource]="profileItems"
               [grouped]="true"
               [showClearButton]="true"
               displayExpr="label"
               placeholder="Select profile item...">
</dx-select-box>
